import { Modals } from "src/modals";
import { omniAtom } from "src/utils/atoms";

export const modalsAtom = omniAtom({
  key: "modals",
  value: [] as Modals[],
});
